export const MONEY_AMOUNT_REGEX = /^\d+(\.\d{1,2})?$/;
